module.exports = __webpack_public_path__ + "static/media/inetcpl_1306.81953c4f.ico";